import { getApolloClient } from '@confluence/graphql';
import { NativeCollabQuery } from '@confluence/native-collab';

export const refetchEditorContent = async (contentId: string) => {
	try {
		return await getApolloClient().query({
			query: NativeCollabQuery,
			context: { single: true },
			fetchPolicy: 'network-only',
			variables: { contentId, status: ['draft', 'current'] }, // For live docs, we need to fetch the current status instead of draft as live docs don't have drafts
		});
	} catch (error) {
		// NOTE: We intentionally swallow any possible error here as this query is only aimed
		// populate the cache with just published content. Should any error occur here after
		// successful publishing the page, the Apollo cache for the query will be invalidated
		// anyway and View Page will fetch the page and handle possible errors.
	}
};
